<div class="profile-image-container w-100 h-100">
    <div class="modal-content-container px-sm-1 p-md-1 mt-4 d-flex justify-content-center">
        <div class="back-btn">
            <i (click)="backBtn()" *ngIf="stepChangeImage === stepChangeImageOptions.CROP_IMAGE"
               class="pi pi-arrow-left cursor-pointer"></i>
        </div>
        <a id="close-dialog-alta" class="close-dialog" (click)="closeModal()">
            <img src="assets/images/icons/close_dialog_icon.svg" alt="close">
        </a>

        <div>
            <form class="phrase-img-form-container" [formGroup]="phraseImgSecurityForm" (ngSubmit)="cropImage()">
                <div class="phrase-img-title-container text-center">
                    {{ 'Registra tu frase e imagen de seguridad' | translate }}
                </div>
                <div>
                    <label class="mt-4 mb-2 new-phrase-label"
                    >{{ 'Nueva frase de seguridad' | translate }}</label>
                    <input type="text" formControlName="phraseSecurity" name="phraseSecurity"
                           class="form-control input-custom"
                           [placeholder]="'Escribe aquí tu nueva frase'|translate" [maxLength]="30" [minLength]="5"
                           [ngClass]="{'input-error': this.phraseImgSecurityForm.get('phraseSecurity')?.invalid && formIsTouched()}"/>

                    <div class="validate-container">
                        <img *ngIf="formIsTouched()
                        && this.phraseImgSecurityForm.get('phraseSecurity').value!=''"
                             [src]="validationIcon('minlength')"
                             alt="monex" width="18px" height="18px">

                        <div [ngClass]="{'invalid': this.phraseImgSecurityForm.get('phraseSecurity').hasError('minlength') && formIsTouched()}"
                             class="d-flex ms-2">
                            <li *ngIf="!(formIsTouched() && this.phraseImgSecurityForm.get('phraseSecurity').value!='')"></li>
                            {{ 'Debe tener de 5 a 30 carácteres.' | translate }}
                        </div>
                    </div>

                    <div class="validate-container">
                        <img *ngIf="formIsTouched()
                        && this.phraseImgSecurityForm.get('phraseSecurity').value!=''"
                             [src]="validationIcon('pattern')"
                             alt="monex" width="18px" height="18px">

                        <div [ngClass]="{'invalid': this.phraseImgSecurityForm.get('phraseSecurity').hasError('pattern') && formIsTouched()}"
                             class="d-flex ms-2">
                            <li *ngIf="!(formIsTouched() && this.phraseImgSecurityForm.get('phraseSecurity').value!='')"></li>
                            {{ 'No usar caracteres especiales' | translate }}
                        </div>
                    </div>
                </div>

                <div class="step-2" *ngIf="stepChangeImage === stepChangeImageOptions.UPLOAD_IMAGE">
                    <div class="d-flex justify-content-center">
                        <label class=" mt-4 select-img-label"> {{ 'Elige tu imagen de seguridad' |translate }}</label>
                    </div>

                    <div class="file-upload-container text-center d-flex align-items-center mt-3"
                         (drop)="onDrop($event)" (dragover)="onDragOver($event)">
                        <div>
                            <div class="file-icon-container">
                                <img src="assets/icons/Upload_Outline.png">
                            </div>
                            <div class="label-upload-container mt-2 text-center ">
                                <p>{{ 'Arrastra y suelta tu imagen o '|translate }}</p>
                                <div class="">
                                    <input (change)="onFileSelected($event)" type="file" formControlName="imageSecurity"
                                           id="files" class="hidden"
                                           style="display: none" accept=".png, .jpg, .jpeg"/>
                                    <label class="click-upload" style=""
                                           for="files">{{ 'haz click aquí'|translate }}</label>
                                </div>
                                <p> {{ 'para cargarla.'|translate }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="step-3" *ngIf="stepChangeImage === stepChangeImageOptions.CROP_IMAGE">
                    <div class="change-photo-container text-center">
                        {{ 'changeProfilePhoto.step3.title' | translate }}
                    </div>
                    <image-cropper

                            [imageChangedEvent]="imageChangedEvent"
                            [maintainAspectRatio]="true"
                            [aspectRatio]="1 / 1"
                            [roundCropper]="true"
                            [backgroundColor]="'red'"
                            format="png"
                            [imageBase64]="imageUrl"
                            (imageCropped)="imageCropped($event)"
                            (imageLoaded)="imageLoaded($event)"
                            (cropperReady)="cropperReady()"
                            (loadImageFailed)="loadImageFailed()"
                    ></image-cropper>
                </div>

                <div class="upload-btn-container d-flex justify-content-center text-center mt-2">
                    <div class="validate-file-container mt-2">
                        <button *ngIf="!this.loading" type="submit" class="btn btn-primary"
                                [disabled]="this.phraseImgSecurityForm.invalid">
                            {{ 'Guardar'|translate }}
                        </button>
                        <div *ngIf="this.loading" class="loading">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            {{ 'Guardando'|translate }}...
                        </div>
                    </div>
                </div>
            </form>
        </div>


    </div>
</div>
